import React from 'react';
import { useTheme } from '../lib/theme';

// logo-02 = WHITE wordmark (#fff)  → dark mode
// logo-03 = BLACK wordmark (#231f20) → light mode
// logo-01 = circular favicon mark (used in browser tab + small touchpoints)
const WHITE_LOGO = 'https://customer-assets.emergentagent.com/job_32a2f735-7599-41ab-8995-99b8947ff2bc/artifacts/oaphoney_PackCheck%20logo-02.svg';
const BLACK_LOGO = 'https://customer-assets.emergentagent.com/job_32a2f735-7599-41ab-8995-99b8947ff2bc/artifacts/p6p99etr_PackCheck%20logo-03.svg';
export const PACKCHECK_FAVICON = 'https://customer-assets.emergentagent.com/job_32a2f735-7599-41ab-8995-99b8947ff2bc/artifacts/ms2vh0hb_PackCheck%20logo-01.svg';

export const PackCheckLogo = ({ height = 28, className = '' }) => {
  const { theme } = useTheme();
  const src = theme === 'dark' ? WHITE_LOGO : BLACK_LOGO;
  // 10px safe space around the logo at all times (per brand guideline).
  return (
    <span className={`inline-block p-[10px] ${className}`} data-testid="packcheck-logo-wrap">
      <img src={src} alt="PackCheck" style={{ height, display: 'block' }} data-testid="packcheck-logo" />
    </span>
  );
};

export const PackCheckMark = ({ size = 24, className = '' }) => (
  <span className={`inline-block p-[10px] ${className}`}>
    <img src={PACKCHECK_FAVICON} alt="PackCheck" style={{ width: size, height: size, display: 'block' }} data-testid="packcheck-mark" />
  </span>
);
